// src/components/layout/Navbar.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navbar: React.FC = () => {
  const [error, setError] = useState('');
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      setError('');
      await logout();
      navigate('/login');
    } catch (err) {
      setError('Failed to log out');
      console.error(err);
    }
  };

  return (
    <nav className="bg-indigo-600 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <h1 className="text-xl font-bold">PCR4 Assignment</h1>
          <span className="text-sm px-3 py-1 bg-indigo-700 rounded-md">Student</span>
        </div>
        
        <div className="flex items-center space-x-4">
          {currentUser && (
            <>
              <span className="text-sm">{currentUser.email}</span>
              <button 
                onClick={handleLogout}
                className="px-3 py-1 bg-red-500 hover:bg-red-600 rounded-md text-sm"
              >
                Logout
              </button>
            </>
          )}
        </div>
      </div>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-2" role="alert">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
    </nav>
  );
};

export default Navbar;